var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip-level",class:[{'big': _vm.big}],style:(_vm.style)},[_c('div',{staticClass:"square",style:(_vm.border)}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.level))])])}
var staticRenderFns = []

export { render, staticRenderFns }